import { toUrlSafe } from 'utils/stringHelpers'

const pluralizeAdvisoryTypeSlug = advisoryActivityType => {
  const typeSlug = toUrlSafe(advisoryActivityType)
  // Types such as service_learning_projects are already plural in the CMS.
  return typeSlug.endsWith('s') ? typeSlug : `${typeSlug}s`
}

export const createHref = (product, activity) => {
  if (activity?.url) {
    return activity.url
  }

  const { advisoryActivityType, pageData } = activity || {}
  const { route } = pageData || {}
  if (product && advisoryActivityType && route) {
    return `/product/${product}/advisory-activities/${pluralizeAdvisoryTypeSlug(
      advisoryActivityType,
    )}/${toUrlSafe(route)}`
  }
}
